import { z } from 'zod';
const key = 'drawonamap.recent-exports.v1';
const record = z.object({
  id: z.string().regex(/^[a-f0-9]{64}$/), format: z.enum(['pdf', 'png']),
  createdAt: z.number(), expiresAt: z.number(), delivered: z.boolean(),
});
export type RecentExport = z.infer<typeof record>;
export function recentExports(): RecentExport[] {
  try {
    return z.array(record).parse(JSON.parse(localStorage.getItem(key) ?? '[]'))
      .filter(item => item.expiresAt > Date.now()).slice(0, 20);
  } catch { return []; }
}
export function rememberRecentExport(id: string, format: 'pdf' | 'png', delivered: boolean): void {
  const items = recentExports();
  const previous = items.find(item => item.id === id);
  const next = record.safeParse({ id, format, createdAt: previous?.createdAt ?? Date.now(),
    expiresAt: previous?.expiresAt ?? Date.now() + 30 * 86400000, delivered: delivered || previous?.delivered || false });
  if (!next.success) return;
  try { localStorage.setItem(key, JSON.stringify([next.data, ...items.filter(item => item.id !== id)].slice(0, 20))); } catch {}
}
